// extracted by mini-css-extract-plugin
module.exports = {"FixIcon":"chat-icon_FixIcon__IIAYD","change-size":"chat-icon_change-size__SLzvA","change-rate":"chat-icon_change-rate__f0fCB","fadeNotice":"chat-icon_fadeNotice___WxJX"};